import React from 'react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  const steps = [{
    number: '1',
    title: 'Base Monocromática',
    desc: 'Crea una columna de color que el ojo seguirá de arriba abajo'
  }, {
    number: '2',
    title: 'La Capa Estructural',
    desc: 'Un blazer o cárdigan abierto recorta visualmente los costados del torso'
  }, {
    number: '3',
    title: 'El Punto de Quiebre',
    desc: 'Marca una zona específica para crear proporción y silueta instantánea'
  }];
  return <section className="bg-brand-text py-12 sm:py-20 px-4 relative overflow-hidden" data-id="element-212">
      <div className="max-w-content mx-auto relative z-10" data-id="element-213">
        <FadeIn data-id="element-214">
          <div className="w-16 h-1 bg-brand-accent mx-auto mb-8 rounded-full" data-id="element-215"></div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center text-brand-bg mb-4" data-id="element-216">
            Presentamos: El Método de Estructura Visual de 3 Capas
          </h2>
          <p className="text-brand-bg/80 text-center text-lg mb-12 font-medium" data-id="element-217">
            No es moda. Es geometría aplicada a tu cuerpo.
          </p>
        </FadeIn>

        <div className="space-y-8 mb-12" data-id="element-218">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-219">
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 text-center sm:text-left" data-id="element-220">
                <div className="flex-shrink-0 w-12 h-12 rounded-full border-2 border-brand-accent flex items-center justify-center text-brand-accent font-serif text-2xl font-bold" data-id="element-221">
                  {step.number}
                </div>
                <div className="pt-1" data-id="element-222">
                  <h3 className="text-xl font-bold text-brand-bg mb-2" data-id="element-223">
                    {step.title}
                  </h3>
                  <p className="text-brand-bg/70 leading-relaxed" data-id="element-224">
                    → {step.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-225">
          <div className="bg-brand-accent/10 border border-brand-accent/30 rounded-xl p-6 text-center" data-id="element-226">
            <p className="text-brand-bg font-bold text-lg sm:text-xl" data-id="element-227">
              Resultado: hasta 7 kilos menos de apariencia visual sin cambiar tu
              peso
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}